/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation036.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation036Item {
  icon: string;
  text: string;
  subtitle?: string;
}

interface IAnimation036Props {
  items: IAnimation036Item[];
  pic?: string;
  title: string;
  className?: string | null;
  onCompleted: () => void;
}

const Animation036: FunctionComponent<IAnimation036Props> = ({
  items,
  pic,
  title,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [show2, setShow2] = useState(true);

  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation036 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation036 component ${className}`}>
      <div className="animation036-content">
        {items.map((itm: IAnimation036Item, idx: number) => (
          <div
            key={idx}
            className={`animation036-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => clickToPlay()}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div className="animation036-indicate-number">
              <img src={getImg(itm.icon)} alt="" />
            </div>
            <div className="animation036-subcontent">
              <div className="animation036-text">
                <div className="animation036-text-content">
                  {itm.text}
                  {itm.subtitle ? (
                    <span className="text sub-task-text">
                      <Button
                        style={{ fontSize: '1.4rem' }}
                        type="link"
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalOpen(true);
                          setShow2(false);
                        }}
                      >
                        {itm.subtitle}
                        <img
                          className="click-point1"
                          hidden={!show2}
                          src={ImgPoint}
                          alt=""
                        />
                      </Button>
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {pic && (
        <Modal
          width="80%"
          className="animation036-modal-ngo"
          title={
            <div
              className="animation036-modal-header"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <div className="border">
            <img src={require(`../../../../../assets/${pic}`).default} alt="" />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Animation036;
